import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate } from '../../utils/helpers';
import GuestForm from './GuestForm';

const RSVP = ['Yes', 'Maybe', 'No'];
const mapUrl = (f) => (f.GpsLocation ? `https://maps.google.com/?q=${encodeURIComponent(f.GpsLocation)}`
  : f.VenueAddress || f.Venue ? `https://maps.google.com/?q=${encodeURIComponent([f.Venue, f.VenueAddress, f.City].filter(Boolean).join(', '))}` : '');

// Desktop guest screen: invitations on the left, the people I bring on the right.
// Logic: useGuestHome.
export default function GuestHomeDesktop({ vm }) {
  const { event, displayName, loading, invitations, rsvp, savingRsvp, mine, fnName, idsOf, openAdd, openEdit, remove, formOpen, signOut } = vm;

  return (
    <div className="guest-home">
      <header className="guest-home-bar">
        <div>
          <div className="guest-home-event">{event.EventName}</div>
          <div className="muted">Signed in as {displayName}</div>
        </div>
        <button className="btn light" onClick={signOut}>Sign out</button>
      </header>

      {loading ? <Spinner /> : (
        <div className="guest-home-cols">
          <section>
            <h2>Your invitation</h2>
            {invitations.length === 0 && (
              <div className="card card-pad muted">Your number is not on the guest list itself, but you can add the people you are bringing.</div>
            )}
            {invitations.map(inv => (
              <div key={inv.GuestId} className="card card-pad guest-invite">
                <div className="guest-invite-fns">
                  {inv.functions.map(f => (
                    <div key={f.FunctionId} className="guest-invite-fn">
                      <strong>{f.FunctionName}</strong>
                      <span className="muted">{[fmtDate(f.FunctionDate), f.FunctionTime, f.Venue].filter(Boolean).join(' · ')}</span>
                      {mapUrl(f) && <a href={mapUrl(f)} target="_blank" rel="noreferrer">Map</a>}
                    </div>
                  ))}
                </div>
                <div className="guest-rsvp">
                  <span className="muted">Will you come?</span>
                  {RSVP.map(a => (
                    <button key={a} className={'chip-toggle' + (inv.RSVPStatus === a ? ' on' : '')}
                      disabled={savingRsvp === inv.GuestId} onClick={() => rsvp(inv, a)}>{a}</button>
                  ))}
                </div>
              </div>
            ))}
          </section>

          <section>
            <div className="guest-home-head">
              <h2>People you are bringing <span className="count-pill">{mine.length}</span></h2>
              <button className="btn primary" onClick={openAdd}>+ Add guest</button>
            </div>
            {mine.length === 0 ? (
              <div className="card card-pad muted">Nobody yet. Add family and friends coming with you.</div>
            ) : (
              <div className="card table-wrap">
                <table className="tbl compact">
                  <thead><tr><th>Name</th><th>Mobile</th><th>Functions</th><th></th></tr></thead>
                  <tbody>
                    {mine.map(r => (
                      <tr key={r.GuestId}>
                        <td style={{ fontWeight: 600 }}>{[r.Surname, r.GuestName].filter(Boolean).join(' ')}</td>
                        <td>{r.MobileNumber || '—'}</td>
                        <td style={{ whiteSpace: 'normal' }}>{r.FunctionNames || idsOf(r).map(fnName).join(', ')}</td>
                        <td style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
                          <button className="icon-btn" title="Edit" onClick={() => openEdit(r)}>✎</button>
                          <button className="icon-btn danger" title="Remove" onClick={() => remove(r)}>🗑</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        </div>
      )}
      {formOpen && <GuestForm vm={vm} />}
    </div>
  );
}
